<template>
    <div class="container">
        <el-container>
            <el-container>
                <el-main>
                    <el-row v-if="userInfo.basic">
                        <span><el-image style="width: 50px;" :src="userInfo.basic.avatar"/> </span>
                        <span>昵称: ( {{userInfo.basic.nickname}} )</span>
                        <span>手机号: ( {{userInfo.basic.mobile}} )</span>
                        <span>CID: ( {{userInfo.basic.cid}} )</span>
                        <span>Invite: ( {{userInfo.basic.invite_id}} )</span>
                        <span>关注: ( {{userInfo.basic.subscribe ? '是' : '否'}} )</span>
                    </el-row>
                    <h2 v-if="setting">正在处理: {{currentSetting.name}}</h2>
                    <el-form ref="form" :model="form" v-if="setting">
                        <div v-for="(m , index) in currentSetting.module" :key="index">
                            <component
                                :is="getType(m)"
                                v-model="form.procedure.module[m]"
                                @input-uid="getUserInfo"
                            />
                        </div>
                        <el-form-item label="下个环节">
                            <el-select v-model="form.next" size="mini" placeholder="必须选">
                                <el-option
                                    v-for="(s, key) in getNextList()"
                                    :key="key"
                                    :label="s.name"
                                    :value="key"
                                />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="开始时间">
                            <el-date-picker
                                size="mini"
                                v-model="form.time"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择时间"
                            />
                        </el-form-item>
                        <el-form-item>
                            <el-button size="mini" @click="handleClear">清空</el-button>
                            <el-button size="mini" type="primary" @click="onSubmit">提交</el-button>
                        </el-form-item>
                    </el-form>
                </el-main>
                <el-aside width="400px">
                    <h2>时间线</h2>
                    <el-timeline>
                        <el-timeline-item
                            v-for="(p, index) of procedures"
                            :timestamp="p.time.substr(0, 10)"
                            placement="top"
                            :key="index"
                        >
                            <el-card>
                                <h4>{{getProcedureName(p.keyword)}}</h4>
                                <el-collapse :accordion="true">
                                    <el-collapse-item
                                        v-for="m of setting[p.keyword]['module']"
                                        :key="m"
                                        :title="modules[m]"
                                    >   
                                        <component
                                            :is="getMessageType(m)"
                                            v-model="p.modules[m]"
                                        />

                                    </el-collapse-item>
                                </el-collapse>
                                <p>{{p['operatorS'] || p.operator }} 更新于: {{p.time}}</p>
                            </el-card>
                        </el-timeline-item>
                    </el-timeline>
                </el-aside>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import request from "../../api/request"
import FormNotes from "../ui/erp/operation/FormNotes.vue"
import FormWeChat from "../ui/erp/operation/FormWeChat.vue"
import FormWeChatGroup from "../ui/erp/operation/FormWeChatGroup.vue"
import FormIdentity from "../ui/erp/operation/FormIdentity.vue"
import FormWithdrawVerify from "../ui/erp/operation/FormWithdrawVerify.vue"
import FormWithdrawProcess from "../ui/erp/operation/FormWithdrawProcess.vue"
import MessageNotes from "../ui/erp/timeline/MessageNotes.vue"
import MessageWeChat from "../ui/erp/timeline/MessageWeChat.vue"
import MessageWeChatGroup from "../ui/erp/timeline/MessageWeChatGroup.vue"
import MessageIdentity from "../ui/erp/timeline/MessageIdentity.vue"
import MessageWithdrawVerify from "../ui/erp/timeline/MessageWithdrawVerify.vue"
import MessageWithdrawProcess from "../ui/erp/timeline/MessageWithdrawProcess.vue"

export default {
    components: {
        FormWeChat,
        FormWeChatGroup,
        FormNotes,
        FormIdentity,
        FormWithdrawVerify,
        FormWithdrawProcess,
        MessageNotes,
        MessageWeChat,
        MessageWeChatGroup,
        MessageIdentity,
        MessageWithdrawVerify,
        MessageWithdrawProcess,
    },
    data: () => ({
        id: 0,
        uid: 0,
        keyword: '',
        userInfo: {},
        procedures: [],
        setting: {},
        next: {},
        modules: {
            notes: '备忘',
            weChatGroup: '社群',
            weChat: '微信',
            identityProcess: '实名状态',
            withdrawProcess: '提现状态',
            withdrawVerify: '提现审核状态',
        },
        form: {
            next: '',
            time: '',
            procedure: {
                name: '',
                module: {}
            }
        }, 
    }),
    created() {
        this.id = parseInt(this.$route.params.id)
        this.classify = this.$route.params.classify
        this.classify === 'user' ? this.uid = parseInt(this.$route.params.uid) : this.uid
        this.getProcedureInfo()
    },
    computed: {
       currentSetting: function () {
           if (this.keyword && this.setting && this.setting.hasOwnProperty(this.keyword)) {
               return this.setting[this.keyword]
           } else {
               return {
                   name: 'loading...',
                   module: []
               }
           }
       }
    },
    methods: {
        getProcedureName(key) {
            return this.setting[key]['name']
        },
        getProcedureInfo() {
            const p = []
            p.push(request.erp.post('procedure_list', {
                circuit_id: this.id
            }))
            p.push(request.erp.post('circuit_setting_get'))
            if (this.uid) {
                p.push(request.agent.post('agent_get_detail', {
                    id: this.uid,
                }))
            }
            Promise.all(p).then(allResp => {                
                this.initFormProcedureData()
                this.keyword = this.$route.params.type
                this.setting = allResp[1].data
                this.procedures = allResp[0].data.list
                if (this.uid) {
                    this.userInfo = allResp[2].data
                }
            })
        },
        onSubmit() {
            const data = this.form
            data.circuit_id = this.id
            data.procedure.name = this.keyword
            if (!data.time) {
                delete data.time
            }
            Object.keys(data.procedure.module).forEach(m => {
                if (this.setting[ this.keyword ].module.indexOf(m) < 0) {
                    delete data.procedure.module[m]
                }
            })
            request.erp.post('circuit_update', data).then(() => {
                this.$message.success('保存成功')
                this.$router.push('/erp')
            })
        },
        handleClear() {
            this.form = {}
        },
        getNextList() {
            if (this.currentSetting.hasOwnProperty('next')) {
                const nextList = {}
                this.currentSetting['next'].forEach(n => {
                    nextList[n] = {name : this.setting[n].name}
                })
                return nextList
            } else {
                return this.setting
            }
        },
        getType(name) {
            switch (name) {
                case 'notes':
                    return 'form-notes'
                case 'weChat':
                    return 'form-we-chat'
                case 'weChatGroup':
                    return 'form-we-chat-group'
                case 'identityProcess':
                    return 'form-identity'
                case 'withdrawVerify':
                    return 'form-withdraw-verify'
                case 'withdrawProcess':
                    return 'form-withdraw-process'
            }
        },
        getMessageType(name) {
            switch (name) {
                case 'notes':
                    return 'message-notes'
                case 'weChat':
                    return 'message-we-chat'
                case 'weChatGroup':
                    return 'message-we-chat-group'
                case 'identityProcess':
                    return 'message-identity'
                case 'withdrawVerify':
                    return 'message-withdraw-verify'
                case 'withdrawProcess':
                    return 'message-withdraw-process'
            }
        },
        initFormProcedureData() {
            this.currentSetting.module.forEach(m => {
                this.form.procedure.module[m] = {}
            })
        },
        getUserInfo(val) {
            if (val) {
                request.agent.post('agent_get_detail', {
                    id: val,
                })
                .then(response => {
                    this.userInfo = response.data
                })
            }
        }
    }
}
</script>
